import { userType } from '../../config/usertypeValue';

export default function fieldDisable(statusId, RelevantType) {
    // //console.log('statusId, RelevantType', statusId, RelevantType)

    // let fieldType = (statusId === 2 || statusId === 6) ?
    //     ((RelevantType === 'Relevant') ? 'disabled' : '')
    //     : 'disabled';
    //     //console.log('fieldType',fieldType)
    // return fieldType;
    if (statusId === 2) {
        if (userType.value === 'L1 Checklist') {
            return (RelevantType === 'Relevant') ? 'disabled' : '';
        }
        return '';
    }
    // if (userType.value === 'L1 Checklist') {
    //     return (statusId === 2) ? '' : 'disabled';
    // }
    if (statusId === 6) {
        if (userType.value === 'L2 Checklist') {
            return (RelevantType === 'Relevant') ? 'disabled' : '';
        }
        return (userType.value === 'L1 Checklist') ? 'disabled' : '';
    }
    // if (userType.value === 'L2 Checklist') {
    //     return (statusId === 6) ? '' : 'disabled';
    // }
    if (statusId !== 2 || statusId !== 6) {
        return 'disabled';
    }
    // if (statusId === 2) {
    //     return '';
    // }
}

